// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import Container from '@/components/global-components/Container';
import InformationCard from '@/components/global-components/information-card/InformationCard';
import StyledCard from '@/components/global-components/styled-card/StyledCard';

// Themes
import theme from '@/themes/index';

const SocialResponsibilityBody = ({
  content: {
    title,
    description,
    highlightedText,
    communityInformation,
  },
}) => {
  return (
    <>
      <section className='main-content'>
        <div className='figure pura-vida-figure'>
          <img src={'/assets/images/Asset_1.png'}/>
        </div>
        <Container>
          <h3>{title}</h3>
          <RichText render={description} />
          <div className='highlighted'>
            <RichText render={highlightedText} />
          </div>
        </Container>
      </section>
      <section className='community-information'>
        <Container>
          <StyledCard
            content={communityInformation}
            containerStyle={{
              flexDirection: 'column-reverse',
            }}
            infoContainerStyle={{
              padding: 0,
            }}
          >
            <div className='information'>
              <InformationCard 
                content={communityInformation} 
                showTitle={true} 
                titleStyle={{
                  color: theme.fontColors.optional5,
                }} 
              />
            </div>
          </StyledCard>
        </Container>
      </section>
      <style jsx>{`
        section.main-content {
          display: flex;
          flex-direction: column;
          padding: 5rem 2rem;
          text-align: center;
        }

        section.main-content h3 {
          margin-block-start: 0;
          margin-block-end: 1rem;
          line-height: 1.875rem;
        }

        section.main-content .highlighted {
          padding-top: 2rem;
          display: flex;
          justify-content: center;
          text-align: center;
        }

        section.community-information {
          padding: 4rem 0;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.main-content h3 {
            margin-block-end: 2rem;
            line-height: 3.375rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.main-content {
            padding: 5rem 2rem;
            text-align: left;
            position: relative;
          }

          section.main-content h3 {
            line-height: 5.375rem;
          }

          section.main-content .highlighted {
            padding-top: 5rem;
          }

          section.community-information {
            padding: 5rem 2rem;
          }

          section.community-information .information {
            padding-top: 4rem;
          }
        }
      `}</style>
      <style global jsx>{`
        section.main-content p {
          font-size: 1rem;
          line-height: 1.575rem;
        }

        section.main-content p a {
          font-size: 1rem;
          line-height: 1.575rem;
          color: ${theme.fontColors.primary};
        }

        section.main-content .highlighted h5 {
          margin-block-start: 0;
          margin-block-end: 0;
          line-height: 1.575rem;
        }

        section.main-content .figure{
          z-index: -1;
          top: 1rem;
          right: 3%;
          width: 250px;
          -webkit-flex-flow: row-reverse;
          -ms-flex-flow: row-reverse;
          flex-flow: row-reverse;
          position: absolute;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          margin: 0 auto;
        }

        section.main-content .figure img{
          width: 100%;
        }

        section.community-information .container .info-container .information .card-content p a {
          color: ${theme.fontColors.primary}
        }

        section.community-information .container .info-container .information .card-content h4 {
          font-family: ${theme.fontFamilies.montserratBold};
        }

        section.community-information .container .info-container .information .card-content h6 {
          color: ${theme.fontColors.optional4};
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.main-content .highlighted h5 {
            line-height: 2rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.main-content p {
            font-size: 1.25rem;
            line-height: 1.875rem;
          }
          section.main-content p a {
            font-size: 1.25rem;
            line-height: 1.875rem;
          }

          section.main-content .highlighted h5 {
            max-width: 72.625rem;
            line-height: 3rem;
          }

          section.community-information .container .info-container .information .card-content h4 {
            font-size: 2rem;
            line-height: 3rem;
          }

          section.community-information .container .info-container .information .card-content p a {

            color: ${theme.fontColors.primary}
          }
        }
      `}</style>
    </>
  );
};

export default SocialResponsibilityBody;
